<template>
    <div class="space-y-6">
        <!-- 音乐标签设置 -->
        <div class="card bg-base-100 shadow-lg border border-base-200" v-if="getIsSuperuser">
            <div class="card-body">
                <h2 class="card-title text-lg font-semibold mb-4 flex items-center">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z">
                        </path>
                    </svg>
                    音乐标签设置
                </h2>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <!-- 本地音乐标签 -->
                    <div class="space-y-3">
                        <div class="flex items-center">
                            <svg class="w-4 h-4 mr-2 text-primary" fill="none" stroke="currentColor"
                                viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3">
                                </path>
                            </svg>
                            <h3 class="font-medium text-base-content">本地音乐标签写入位置</h3>
                        </div>
                        <div class="pl-6 space-y-2">
                            <div class="form-control">
                                <label class="label cursor-pointer justify-start gap-3 py-2">
                                    <input type="checkbox" class="checkbox checkbox-primary"
                                        v-model="formData.save_in_metadata" @change="updateSys('save_in_metadata')" />
                                    <span class="label-text font-medium">元数据</span>
                                </label>
                            </div>
                            <div class="form-control">
                                <label class="label cursor-pointer justify-start gap-3 py-2">
                                    <input type="checkbox" class="checkbox checkbox-primary"
                                        v-model="formData.save_in_db" @change="updateSys('save_in_db')" />
                                    <span class="label-text font-medium">音乐收藏</span>
                                </label>
                            </div>
                        </div>
                        <div class="alert py-2">
                            <svg class="stroke-current shrink-0 w-4 h-4" fill="none" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                            <span class="text-sm">元数据：内嵌进音乐文件中。音乐收藏：音乐标签提供的数据库</span>
                        </div>
                    </div>

                    <!-- WebDAV音乐标签 -->
                    <div class="space-y-3">
                        <div class="flex items-center">
                            <svg class="w-4 h-4 mr-2 text-secondary" fill="none" stroke="currentColor"
                                viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10">
                                </path>
                            </svg>
                            <h3 class="font-medium text-base-content">WebDAV音乐标签写入位置</h3>
                        </div>
                        <div class="pl-6 space-y-2">
                            <div class="form-control">
                                <label class="label cursor-pointer justify-start gap-3 py-2">
                                    <input type="checkbox" class="checkbox checkbox-secondary"
                                        v-model="formData.save_in_metadata_wb"
                                        @change="updateSys('save_in_metadata_wb')" />
                                    <span class="label-text font-medium">元数据</span>
                                </label>
                            </div>
                            <div class="form-control">
                                <label class="label cursor-pointer justify-start gap-3 py-2">
                                    <input type="checkbox" class="checkbox checkbox-secondary"
                                        v-model="formData.save_in_db_wb" @change="updateSys('save_in_db_wb')" />
                                    <span class="label-text font-medium">音乐收藏</span>
                                </label>
                            </div>
                        </div>
                        <div class="alert py-2">
                            <svg class="stroke-current shrink-0 w-4 h-4" fill="none" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                            <span class="text-sm">元数据：内嵌进音乐文件中。音乐收藏：音乐标签提供的数据库</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 文件显示设置 -->
        <div class="card bg-base-100 shadow-lg border border-base-200" v-if="getIsSuperuser">
            <div class="card-body">
                <h2 class="card-title text-lg font-semibold mb-4 flex items-center">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"></path>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M8 5a2 2 0 012-2h4a2 2 0 012 2v2H8V5z"></path>
                    </svg>
                    文件显示设置
                </h2>

                <div class="space-y-6">
                    <!-- 文件显示数量 -->
                    <div class="form-control w-full max-w-md">
                        <label class="label">
                            <span class="label-text font-medium">文件显示数量</span>
                        </label>
                        <input type="number" min="0" placeholder="请输入数量" v-model="formData.file_list_limit"
                            @change="updateSys('file_list_limit')" class="input input-bordered focus:input-primary" />
                        <label class="label">
                            <span class="label-text-alt text-base-content/70">操作台单个目录下的文件夹显示限制，默认为 5000</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <!-- 元数据版本历史 -->
        <div class="card bg-base-100 shadow-lg border border-base-200" v-if="getIsSuperuser">
            <div class="card-body">
                <h2 class="card-title text-lg font-semibold mb-4 flex items-center">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4">
                        </path>
                    </svg>
                    元数据版本管理
                </h2>

                <div class="space-y-6">
                    <!-- ID3 元数据版本 -->
                    <div class="space-y-4">
                        <div class="flex items-center gap-2">
                            <svg class="w-5 h-5 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z">
                                </path>
                            </svg>
                            <h3 class="font-semibold text-base">ID3 元数据版本</h3>
                        </div>

                        <div class="pl-7 space-y-4">
                            <div class="form-control w-full max-w-md">
                                <label class="label">
                                    <span class="label-text font-medium">ID3 版本</span>
                                </label>
                                <select class="select select-bordered focus:select-accent w-full"
                                    v-model="formData.id3_version" @change="updateSys('id3_version')">
                                    <option value="2.3">ID3v2.3</option>
                                    <option value="2.4">ID3v2.4</option>
                                </select>
                                <label class="label">
                                    <span class="label-text-alt text-base-content/70">
                                        选择写入音乐文件的 ID3 标签版本，默认为 ID3v2.4
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- 元数据版本历史 -->
                    <div class="space-y-4">
                        <div class="flex items-center gap-2">
                            <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                            <h3 class="font-semibold text-base">元数据版本历史</h3>
                        </div>

                        <div class="pl-7 space-y-4">
                            <!-- 启用版本历史开关 -->
                            <div class="form-control">
                                <label class="label cursor-pointer justify-start gap-4">
                                    <span class="label-text font-medium">启用版本历史</span>
                                    <input type="checkbox" class="toggle toggle-primary toggle-lg"
                                        v-model="formData.metadata_version_enabled"
                                        @change="updateSys('metadata_version_enabled')" />
                                </label>
                                <label class="label">
                                    <span class="label-text-alt text-base-content/70">
                                        自动记录每次元数据修改的历史版本,支持查看差异和回退操作
                                    </span>
                                </label>
                            </div>

                            <!-- 保留历史版本数量 -->
                            <div class="form-control w-full max-w-md" v-if="formData.metadata_version_enabled">
                                <label class="label">
                                    <span class="label-text font-medium">保留历史版本数量</span>
                                </label>
                                <div class="join w-full">
                                    <input type="number" min="1" max="100" placeholder="默认50条"
                                        v-model.number="formData.metadata_version_max_count"
                                        @change="updateSys('metadata_version_max_count')"
                                        class="input input-bordered  join-item flex-1" />
                                    <span class="btn btn-primary join-item no-animation">条</span>
                                </div>
                                <label class="label">
                                    <span class="label-text-alt text-base-content/70">
                                        超过此数量时,将自动删除最旧的版本记录(1-100条,默认50条)
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Subsonic 配置设置 -->
        <div class="card bg-base-100 shadow-lg border border-base-200">
            <div class="card-body">
                <h2 class="card-title text-lg font-semibold mb-4 flex items-center">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z">
                        </path>
                    </svg>
                    Subsonic 服务
                    <div class="badge badge-secondary badge-sm ml-2">个人配置</div>
                </h2>

                <div class="bg-base-200/50 rounded-lg p-6 space-y-4">
                    <div class="form-control">

                        <div class="p-3 bg-success/10 rounded-lg border border-success/20">
                            <div class="text-sm text-base-content/80">
                                <p class="mb-2 font-medium">本系统内置Subsonic服务器，提供以下功能：</p>
                                <ul class="list-disc list-inside space-y-1 text-xs">
                                    <li>通过网络播放个人音乐收藏</li>
                                    <li>支持多种音乐格式（MP3、FLAC、OGG等）</li>
                                    <li>实时转码以适应不同设备</li>
                                    <li>播放列表管理和多用户支持</li>
                                    <li>跨平台客户端支持（Web、手机APP、桌面客户端）</li>
                                </ul>
                                <div class="mt-2 p-2 bg-base-100 rounded border border-base-300">
                                    <div class="flex items-center gap-2 text-xs">
                                        <svg class="w-3 h-3 text-info" fill="none" stroke="currentColor"
                                            viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                        </svg>
                                        <span>配置您的个人Subsonic账号密码后，可使用各种Subsonic客户端连接此服务器</span>
                                    </div>
                                    <div class="text-xs text-base-content/60 mt-1 flex items-center gap-1">
                                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                        </svg>
                                        <span>此密码配置仅对您当前账户有效</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="space-y-4">
                        <div class="form-control w-full max-w-md">
                            <label class="label">
                                <span class="label-text font-medium">服务器配置</span>
                            </label>
                            <div class="grid grid-cols-1 gap-4">
                                <div class="form-control">
                                    <label class="label">
                                        <span class="label-text-alt">服务器地址</span>
                                    </label>
                                    <input type="text" :value="getServerUrl()" readonly
                                        class="input input-bordered bg-base-200 cursor-not-allowed" />
                                </div>
                                <div class="form-control">
                                    <label class="label">
                                        <span class="label-text-alt">用户名</span>
                                    </label>
                                    <input type="text" :value="getUsername" readonly
                                        class="input input-bordered bg-base-200 cursor-not-allowed" />
                                </div>
                                <div class="form-control">
                                    <label class="label">
                                        <span class="label-text font-medium">密码</span>
                                    </label>
                                    <div class="relative">
                                        <input :type="showPassword ? 'text' : 'password'" placeholder="请输入密码"
                                            v-model="subsonicPassword" @change="updateSubsonicPassword"
                                            class="input input-bordered focus:input-primary w-full" />
                                        <button class="absolute right-2 top-1/2 -translate-y-1/2"
                                            @click="showPassword = !showPassword">
                                            <svg v-if="showPassword" class="w-5 h-5 text-base-content/60" fill="none"
                                                stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                            </svg>
                                            <svg v-else class="w-5 h-5 text-base-content/60" fill="none"
                                                stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Last.fm 记录设置 -->
        <div class="card bg-base-100 shadow-lg border border-base-200">
            <div class="card-body">
                <h2 class="card-title text-lg font-semibold mb-4 flex items-center">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3">
                        </path>
                    </svg>
                    Last.fm 音乐记录
                    <div class="badge badge-primary badge-sm ml-2">个人配置</div>
                </h2>

                <div class="bg-base-200/50 rounded-lg p-6 space-y-4">
                    <div class="form-control">
                        <label class="label cursor-pointer justify-start gap-4">
                            <span class="label-text font-medium">开启记录</span>
                            <input type="checkbox" class="toggle toggle-primary toggle-lg"
                                v-model="lastfmConfig.is_record_lastfm"
                                @change="updateLastfmConfig('is_record_lastfm', lastfmConfig.is_record_lastfm)" />
                        </label>
                        <div class="mt-2 p-3 bg-info/10 rounded-lg border border-info/20">
                            <div class="text-sm text-base-content/80 flex items-center flex-wrap gap-1">
                                <span>将您的个人Subsonic账户连接到</span>
                                <button class="link link-primary font-medium" @click="handleOpenLastfm">您的Last.fm
                                    账户</button>
                                <span>，通过任何设备或平台上的播放记录您所听的一切内容。</span>
                            </div>
                            <div class="text-xs text-base-content/60 mt-1 flex items-center gap-1">
                                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                </svg>
                                <span>此配置仅对您当前账户有效，不会影响其他用户</span>
                            </div>
                        </div>
                    </div>

                    <input type="password" name="password1" style="display:none" />

                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">用户名</span>
                            </label>
                            <input type="text" placeholder="请输入用户名" v-model="lastfmConfig.lastfm_user"
                                autocomplete="new-password"
                                @change="updateLastfmConfig('lastfm_user', lastfmConfig.lastfm_user)"
                                class="input input-bordered focus:input-primary" />
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">密码</span>
                            </label>
                            <div class="relative">
                                <input :type="showLastfmPassword ? 'text' : 'password'" placeholder="请输入密码"
                                    v-model="lastfmConfig.lastfm_pass" autocomplete="new-password"
                                    @change="updateLastfmConfig('lastfm_pass', lastfmConfig.lastfm_pass)"
                                    class="input input-bordered focus:input-primary w-full" />
                                <button class="absolute right-2 top-1/2 -translate-y-1/2"
                                    @click="showLastfmPassword = !showLastfmPassword">
                                    <svg v-if="showLastfmPassword" class="w-5 h-5 text-base-content/60" fill="none"
                                        stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                    </svg>
                                    <svg v-else class="w-5 h-5 text-base-content/60" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">API Key</span>
                            </label>
                            <div class="relative">
                                <input :type="showLastfmApiKey ? 'text' : 'password'" placeholder="请输入API Key"
                                    v-model="lastfmConfig.lastfm_api_key"
                                    @change="updateLastfmConfig('lastfm_api_key', lastfmConfig.lastfm_api_key)"
                                    class="input input-bordered focus:input-primary w-full" />
                                <button class="absolute right-2 top-1/2 -translate-y-1/2"
                                    @click="showLastfmApiKey = !showLastfmApiKey">
                                    <svg v-if="showLastfmApiKey" class="w-5 h-5 text-base-content/60" fill="none"
                                        stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                    </svg>
                                    <svg v-else class="w-5 h-5 text-base-content/60" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">API Secret</span>
                            </label>
                            <div class="relative">
                                <input :type="showLastfmApiSecret ? 'text' : 'password'" placeholder="请输入API Secret"
                                    v-model="lastfmConfig.lastfm_api_secret"
                                    @change="updateLastfmConfig('lastfm_api_secret', lastfmConfig.lastfm_api_secret)"
                                    class="input input-bordered focus:input-primary w-full" />
                                <button class="absolute right-2 top-1/2 -translate-y-1/2"
                                    @click="showLastfmApiSecret = !showLastfmApiSecret">
                                    <svg v-if="showLastfmApiSecret" class="w-5 h-5 text-base-content/60" fill="none"
                                        stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                    </svg>
                                    <svg v-else class="w-5 h-5 text-base-content/60" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 播放转码设置 -->
        <div class="card bg-base-100 shadow-lg border border-base-200" v-if="getIsSuperuser">
            <div class="card-body">
                <h2 class="card-title text-lg font-semibold mb-4 flex items-center">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z">
                        </path>
                    </svg>
                    播放转码设置
                </h2>

                <div class="bg-base-200/50 rounded-lg p-6 space-y-4">
                    <div class="form-control">
                        <label class="label cursor-pointer justify-start gap-4">
                            <span class="label-text font-medium">开启转码</span>
                            <input type="checkbox" class="toggle toggle-accent toggle-lg"
                                v-model="formData.is_play_decode" @change="updateSys('is_play_decode')" />
                        </label>
                        <div class="mt-2 p-3 bg-warning/10 rounded-lg border border-warning/20">
                            <div class="text-sm text-base-content/80">
                                播放前会将音乐解码为特定格式，但不是实时转码会耗费时间。
                            </div>
                        </div>
                    </div>

                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">缓存文件数</span>
                            </label>
                            <input type="number" min="0" placeholder="请输入数量" v-model="formData.decode_cache_num"
                                @change="updateSys('decode_cache_num')"
                                class="input input-bordered focus:input-accent" />
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">转码命令</span>
                            </label>
                            <input type="text" placeholder="请输入转码命令" v-model="formData.decode_command"
                                @change="updateSys('decode_command')" class="input input-bordered focus:input-accent" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 配置管理 -->
        <div class="card bg-base-100 shadow-lg border border-base-200" v-if="getIsSuperuser">
            <div class="card-body">
                <h2 class="card-title text-lg font-semibold mb-4 flex items-center">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4">
                        </path>
                    </svg>
                    配置管理
                </h2>

                <div class="flex flex-col sm:flex-row gap-3">
                    <button class="btn btn-primary btn-sm gap-2" @click="handleExportConfig">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                            </path>
                        </svg>
                        导出配置
                    </button>
                    <button class="btn btn-outline btn-sm gap-2" onclick="import_config.showModal()">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10">
                            </path>
                        </svg>
                        导入配置
                    </button>
                </div>
                <div class="mt-3 p-3 bg-neutral/5 rounded-lg border border-neutral/10">
                    <div class="text-sm text-base-content/70">
                        导出系统设置中的所有配置项，方便备份和转移
                    </div>
                </div>
            </div>
        </div>

        <!-- 导入配置弹窗 -->
        <dialog ref="import_config" id="import_config" class="modal modal-bottom sm:modal-middle" v-if="getIsSuperuser">
            <div class="modal-box">
                <h3 class="text-lg font-bold mb-4">导入配置</h3>
                <div class="space-y-4">
                    <div class="form-control w-full">
                        <label class="label">
                            <span class="label-text">选择配置文件</span>
                        </label>
                        <input type="file" class="file-input file-input-bordered file-input-primary w-full"
                            @change="onFileChange" />
                    </div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <button class="btn btn-primary btn-sm mr-2" @click="handleImportConfig">确认导入</button>
                        <button class="btn btn-ghost btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'BasicSettings',
    props: {
        formData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            selectedFile: null,
            showSubsonicPassword: false, // 控制Subsonic密码显示/隐藏
            testingConnection: false, // 控制Subsonic连接测试状态
            connectionStatus: null, // 存储Subsonic连接测试结果
            showPassword: false, // 控制密码显示/隐藏
            subsonicPassword: '', // 存储Subsonic密码
            // Last.fm 密码字段的显示/隐藏状态
            showLastfmPassword: false,
            showLastfmApiKey: false,
            showLastfmApiSecret: false,
            // Last.fm 配置数据
            lastfmConfig: {
                is_record_lastfm: false,
                lastfm_user: '',
                lastfm_pass: '',
                lastfm_api_key: '',
                lastfm_api_secret: ''
            }
        }
    },
    computed: {
        ...mapGetters(['getUsername', 'getIsSuperuser']),
    },
    mounted() {
        this.getSubsonicPassword()
        this.getLastfmConfig()
    },
    methods: {
        updateSys(key) {
            this.$emit('update-sys', key)
        },
        handleOpenLastfm() {
            window.open('https://www.last.fm/api/account/create')
        },
        handleExportConfig() {
            this.$api.Task.exportConfig().then((res) => {
                if (res.result) {
                    window.open(res.data.url)
                }
            })
        },
        handleImportConfig() {
            const formData = new FormData()
            formData.append('file', this.selectedFile)
            this.$api.Task.importConfig(formData).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: '导入成功！',
                        type: 'success',
                        time: 2000,
                    })
                    this.$refs["import_config"].close()
                    // 重新获取配置数据
                    this.$parent.fetchSysDict()
                }
            })
        },
        onFileChange(event) {
            this.selectedFile = event.target.files[0]
        },
        // Subsonic密码测试方法
        async testSubsonicConnection() {
            if (!this.formData.subsonic_password) {
                this.connectionStatus = {
                    success: false,
                    message: '请先设置管理员密码'
                };
                return;
            }

            this.testingConnection = true;
            this.connectionStatus = null;

            try {
                const response = await this.$api.Task.testSubsonicConnection({
                    server: this.getServerUrl(),
                    port: this.formData.subsonic_port || 4040,
                    username: this.formData.subsonic_username || 'admin',
                    password: this.formData.subsonic_password,
                });

                if (response.result) {
                    this.connectionStatus = {
                        success: true,
                        message: '密码验证成功！'
                    };
                } else {
                    this.connectionStatus = {
                        success: false,
                        message: response.message || '密码验证失败，请检查密码'
                    };
                }
            } catch (error) {
                this.connectionStatus = {
                    success: false,
                    message: error.message || '密码验证失败，请检查密码'
                };
            } finally {
                this.testingConnection = false;
            }
        },
        // 切换Subsonic密码显示/隐藏
        toggleSubsonicPassword() {
            this.showSubsonicPassword = !this.showSubsonicPassword;
        },
        // 获取服务器地址
        getServerUrl() {
            if (this.formData.subsonic_server) {
                return this.formData.subsonic_server;
            }
            // 如果没有设置自定义服务器地址，使用当前域名
            return window.location.origin;
        },
        // 打开Subsonic Web界面
        openSubsonicWeb() {
            const serverUrl = this.getServerUrl();
            const port = this.formData.subsonic_port || 4040;
            const fullUrl = `${serverUrl}:${port}`;
            window.open(fullUrl, '_blank');
        },
        getSubsonicPassword() {
            this.$api.Task.subsonicPassword().then((res) => {
                if (res.result) {
                    this.subsonicPassword = res.data.password;
                }
            })
        },
        updateSubsonicPassword() {
            this.$api.Task.updateSubsonicPassword({
                password: this.subsonicPassword
            }).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: '更新成功！',
                        type: 'success',
                        time: 2000,
                    })
                }
            })
        },
        // Last.fm 配置相关方法
        getLastfmConfig() {
            this.$api.Task.lastfmProfile().then((res) => {
                if (res.result) {
                    this.lastfmConfig = { ...this.lastfmConfig, ...res.data }
                }
            }).catch((error) => {
                console.error('获取Last.fm配置失败:', error)
            })
        },
        updateLastfmConfig(key, value) {
            // 更新本地数据
            this.lastfmConfig[key] = value

            // 保存到服务器
            const updateData = { [key]: value }
            this.$api.Task.updateLastfmProfile(updateData).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: 'Last.fm配置更新成功！',
                        type: 'success',
                        time: 2000,
                    })
                } else {
                    this.$myMsg.notify({
                        title: 'Last.fm配置更新失败！',
                        type: 'error',
                        time: 3000,
                    })
                }
            }).catch((error) => {
                console.error('更新Last.fm配置失败:', error)
                this.$myMsg.notify({
                    title: 'Last.fm配置更新失败！',
                    type: 'error',
                    time: 3000,
                })
            })
        }
    }
}
</script>